import React from 'react';
import { map, find } from 'lodash';
import { connect } from 'react-redux';
import OptionDetail from '../../components/optionDetail/OptionDetail';
import HtmlListWithDisclosures from '../../common/HtmlListWithDisclosures';

const Detail = ({ option }) => {
  const { description, label, specsFormatted, specDisclaimers } = option;

  return (
    <div className="drive-type-detail__container">
      <div className="drive-type-detail__header">
        {description} ({label})
      </div>
      <HtmlListWithDisclosures
        className="model-card__features"
        content={specsFormatted}
        disclosures={specDisclaimers}
      />
    </div>
  );
};

const DriveType = ({
  option,
  showImageDisclosure,
  showLegalDisclosure,
  specsLabel,
}) => {
  return (
    <OptionDetail
      showImageDisclosure={showImageDisclosure}
      showLegalDisclosure={showLegalDisclosure}
      option={option}
      detail={<Detail option={option} specsLabel={specsLabel} />}
    />
  );
};

const DriveTypeDetail = ({
  matrix,
  selections,
  showImageDisclosure,
  showLegalDisclosure,
}) => {
  const { bodyType: id } = selections;
  const seledtedBodyType = find(matrix.bodyTypes, { id });
  const { driveTypes } = seledtedBodyType;

  return (
    <>
      {driveTypes
        ? map(driveTypes, (driveType) => (
            <DriveType
              key={driveType.driveType}
              specsLabel={driveType.description}
              option={driveType.dtd}
              showImageDisclosure={showImageDisclosure}
              showLegalDisclosure={showLegalDisclosure}
            />
          ))
        : null}
    </>
  );
};

const mapStateToProps = (state) => {
  const { matrix, config } = state;
  const { selections } = config;
  return {
    matrix,
    selections,
  };
};

export default connect(mapStateToProps)(DriveTypeDetail);
